import { DocumentSubCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadDocumentSubCategory = createAction(
  '[DocumentSubCategory] Load DocumentSubCategory'
);

export const loadDocumentSubCategorySuccess = createAction(
  '[DocumentSubCategory] Load DocumentSubCategory Success',
  props<{ documentSubCategory: DocumentSubCategoryDto[] }>()
);

export const loadDocumentSubCategoryFailure = createAction(
  '[DocumentSubCategory] Load DocumentSubCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addDocumentSubCategory = createAction(
  '[DocumentSubCategory] Add DocumentSubCategory',
  props<{ newDocumentSubCategory: DocumentSubCategoryDto[] }>()
);

export const addDocumentSubCategorySuccess = createAction(
  '[DocumentSubCategory] Add DocumentSubCategory Success',
  props<{ newDocumentSubCategory: DocumentSubCategoryDto[] }>()
);

export const addDocumentSubCategoryFailure = createAction(
  '[DocumentSubCategory] Add DocumentSubCategory Failure',
  props<{ error: any }>()
);

/**
 * Update DocumentSubCategory Collection Actions
 */
export const updateDocumentSubCategory = createAction(
  '[DocumentSubCategory] Update DocumentSubCategory',
  props<{ updateDocumentSubCategory: DocumentSubCategoryDto[] }>()
);

export const updateDocumentSubCategorySuccess = createAction(
  '[DocumentSubCategory] Update DocumentSubCategory Success',
  props<{ updateDocumentSubCategory: DocumentSubCategoryDto[] }>()
);

export const updateDocumentSubCategoryFailure = createAction(
  '[DocumentSubCategory] Update DocumentSubCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove DocumentSubCategory Collection Actions
 */
export const removeDocumentSubCategory = createAction(
  '[DocumentSubCategory] Remove DocumentSubCategory',
  props<{ ids: string[] }>()
);

export const removeDocumentSubCategorySuccess = createAction(
  '[DocumentSubCategory] Remove DocumentSubCategory Success',
  props<{ ids: string[] }>()
);

export const removeDocumentSubCategoryFailure = createAction(
  '[DocumentSubCategory] Remove DocumentSubCategory Failure',
  props<{ error: any }>()
);
